import { UserInfo } from "../types/common";

const ADMIN_PORTAL_ROLES: readonly number[] = [1, 3, 4];

export const isAdminUser = (user?: Pick<UserInfo, "role"> | null): boolean =>
  ADMIN_PORTAL_ROLES.some((role) => role === user?.role);
